import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.delete = this.delete.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            successMessage:''
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    closeModal() {
        window.location.reload();
    }

    delete() {
        const apiUrl = localStorage.getItem('api_url');
        var deleteData = new FormData();
        deleteData.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
        deleteData.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: apiUrl + 'anyDeleteuser',
            data: deleteData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
        .then(res => {
            const status = res.data.status;
            const message = res.data.message;
            if (status === 'true') {
                localStorage.removeItem('session_token'); 
                localStorage.removeItem('session_userid');
                localStorage.clear();
                this.setState({
                    successMessage: message,
                    suc_cls: 'successMsg floatingAlerts1'
                }, () => {
                    this.props.history.push("/"); 
                });
            } else {
                this.setState({
                    successMessage: message,
                    suc_cls: 'errorMsg floatingAlerts1'
                });
            }
         }).catch(error => {
            this.setState({
                successMessage: 'Failed to delete account.',
                suc_cls: 'errorMsg floatingAlerts1'
            });
        });
    }

    render() {
        return (
            <div className='deactivate_account'>
                <h4>
                    <Trans i18nKey="Are you sure you">Are you sure you</Trans> 
                    <br/>
                    <Trans i18nKey="want to deactivate the account ?">want to delete the account ?</Trans>
                </h4>
                <div className='deactivate_button'>
                    <Button onClick={this.delete}><Trans i18nKey="Yes">Yes</Trans></Button>
                    <Button onClick={this.closeModal}><Trans i18nKey="No">No</Trans></Button>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(withRouter(Delete));
